<template>
    <div class="fhv-centent">
        <h4 class="title-topic">WIFI Advanced Settings 5GHz</h4>
        <el-alert title="Some parameters in subRouter mode are forbidden to be modified!" type="warning" show-icon
        :closable="false" v-if="$G_DEVICE_CFG.isSubRouter"></el-alert>
        <el-form 
        :model="wlform"  
        label-width="180px" 
        label-position="left"
        class="fhv-form" 
        size="mini"
        :rules="formCheck" 
        ref="wlform"
        :disabled="$G_DEVICE_CFG.isReadOnly || $G_DEVICE_CFG.isSubRouter"
        v-loading="getLoad"
        >
            <el-form-item label="Mode :" >
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-select v-model="wlform.band" style="width: 100%" placeholder="Please select Mode" 
                :disabled="$G_DEVICE_CFG.isFindSubRouter">
                    <el-option label="802.11a" value="4"></el-option>
                    <el-option label="802.11n" value="8"></el-option>
                    <el-option label="802.11a/n" value="12"></el-option>
                    <el-option label="802.11ac" value="64"></el-option>
                    <el-option label="802.11n/ac" value="72"></el-option>
                    <el-option label="802.11a/n/ac" value="76"></el-option>
                </el-select>
                </el-tooltip>
            </el-form-item>
            <el-form-item label="Bandwidth :" >
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-select v-model="wlform.bandwidth" style="width: 100%" placeholder="Please select Bandwidth"
                :disabled="$G_DEVICE_CFG.isFindSubRouter">
                    <el-option v-for="_bandwidth in bandwidths" :key="_bandwidth.value" :label="_bandwidth.label" :value="_bandwidth.value"></el-option>
                </el-select>
                </el-tooltip>
            </el-form-item>
            <el-form-item label="Enable DFS :" v-if="$isTRUE">
                <el-switch v-model="dsfEnable" @change="setDFS"></el-switch>
            </el-form-item>
            <el-form-item label="Channel :" >
                <el-tooltip :disabled="!$G_DEVICE_CFG.isFindSubRouter" effect="dark" popper-class="wring-text"  placement="top" 
                content="Modifying this parameter may cause the subRouter network to be down. Prohibit operation!">
                <el-select v-model="wlform.channel" style="width: 100%" placeholder="Please select Transmit Power">
                    <el-option :label="wlform.channel !== '0' ? 'auto' : autoText" value="0"></el-option>
                    <el-option 
                    v-for="channelNum in channelNumArr" 
                    :key="channelNum" :label="channelNum" 
                    :value="channelNum"
                    ></el-option>
                </el-select>
                </el-tooltip>
            </el-form-item>
            <!-- 哥伦比亚版本功率配置在基本配置页面 -->
            <el-form-item label="Transmit Power :" v-if="!$isCLARO">
                <el-select v-model="wlform.power" 
                @change="tipReboot"
                style="width: 100%" placeholder="Please select Transmit Power" >
                    <el-option v-if="$isAis" label="Optimized (default)" value="0"></el-option>
                    <el-option v-else label="Standard" value="0"></el-option>
                    <el-option label="Medium" value="1"></el-option>
                    <el-option label="High" value="2"></el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="Beacon Interval :" prop="beaconInterval">
                <el-input v-model="wlform.beaconInterval"></el-input>
            </el-form-item>
            <el-form-item label="RTS Threshold :" prop="rtsThreshold">
                <el-input v-model="wlform.rtsThreshold"></el-input>
            </el-form-item>
            <el-form-item label="Fragment Threshold :" prop="fragThreshold">
                <el-input v-model="wlform.fragThreshold"></el-input>
            </el-form-item>
            <el-form-item label="Maxinum Clients  :" prop="maxinumClients">
                <el-input v-model="wlform.maxinumClients"></el-input>
            </el-form-item>
            <el-form-item label="DTIM Interval  :" prop="dtimPeriod">
                <el-input v-model="wlform.dtimPeriod"></el-input>
            </el-form-item>
            <el-form-item label="Roaming Enable :">
                <el-switch v-model="wlform.roamEnable"></el-switch>
            </el-form-item>
            <el-form-item label="Short GI :">
                <el-switch v-model="wlform.shortGI"></el-switch>
            </el-form-item>
            <el-form-item label="WMM :">
                <el-switch v-model="wlform.wmmEnabled"></el-switch>
            </el-form-item>
            <el-form-item label="WMM APSD :">
                <el-switch v-model="wlform.uapsdEnabled"></el-switch>
            </el-form-item>
            <el-form-item label="Adaptivity Enable :">
                <el-switch v-model="wlform.adaptivityEnable"></el-switch>
            </el-form-item>
            <el-form-item label="ATF Enable :">
                <el-switch v-model="wlform.ATFEnable"></el-switch>
            </el-form-item>
            <el-form-item label="TXBF Enable :">
                <el-switch v-model="wlform.TXBFEnable"></el-switch>
            </el-form-item> 
            <el-form-item>
                <el-button type="primary" @click="apply">Apply</el-button>
                <el-button type="primary" @click="refresh">Refresh</el-button>
            </el-form-item>
        </el-form>
    </div>
    
</template>

<script>
import Reboot from '@/components/reboot.js'
import validator from 'validator'
import devConfig from '@/devConfig'

// 雷达信道开启 可选 '120','124','128','132'
const channelDFSArr = ['36','40','44','48','52','56','60','64','100','104','108','112','116','120','124','128','132','136','140','144','149','153','157','161','165']
const channelNODFSArr = ['36','40','44','48','149','153','157','161','165']

// INTL 巴西版本可选信道范围
const channelArrIntl = ['36','40','44','48','52','56','60','64','100','104','108','112','116','120',
                        '124','128','132','136','140','144','149','153','157','161','165']

// AIS 版本 没有165信道 原因是选择165 导致频宽20Hz
const channelArrAis =  ['36','40','44','48','52','56','60','64','149','153','157','161']
const channelDFSArrAis = ['36','40','44','48','149','153','157','161']

let powerCache = '0'; // 当前配置 power
export default {
    data(){
       return {
           getLoad:false,
           channelNumArr: ['36','40','44','48','52','56','60','64','149','153','157','161','165'],
           dsfEnable:false,
           autoText:'auto',
           wlform:{
                band: "76",
                bandwidth: "0",
                beaconInterval: 100,
                channel: "0",
                controlSideband: "0",
                dtimPeriod: 1,
                fragThreshold: 2346,
                maxinumClients: 32,
                power: "0",
                rtsThreshold: 2347,
                shortGI: true,
                uapsdEnabled: true,
                wmmEnabled: true,
                roamEnable: true,
                ATFEnable:false,
                TXBFEnable:false,
                adaptivityEnable:false // 无线退避开关 默认关闭
           },
           formCheck:{
                beaconInterval:[
                    { required: true, message: 'Beacon interval cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 20, max: 1024}))
                                callback(new Error('Beacon interval is an integer and  range [20-1024].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                dtimPeriod:[
                    { required: true, message: 'DTIM Interval cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 255}))
                                callback(new Error('DTIM Interval is an integer and  range [1-255].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                fragThreshold:[
                    { required: true, message: 'Fragment Threshold cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 2346}))
                                callback(new Error('Fragment Threshold is an integer and  range [1-2346].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                maxinumClients:[
                    { required: true, message: 'Maxinum Clients cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 32}))
                                callback(new Error('Maxinum Clients is an integer and  range [1-32].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ],
                rtsThreshold:[
                    { required: true, message: 'RTS Threshold cannot be empty.', trigger: 'blur' },
                    {
                        validator:(rule, value, callback) => {
                            if(!validator.isInt(value+'',{min: 1, max: 2347}))
                                callback(new Error('Maxinum Clients is an integer and  range [1-2347].'));
                            else
                                 callback()
                        },
                        trigger: 'blur'
                    }
                ]
           } 
       }
    },
    created(){
        devConfig.init(this,()=>{
            this.getData()
        })
        
    },
    computed:{
        bandwidths(){
            let bandwidth = [
                {label:'20 MHz',value:'0'},
                {label:'40 MHz',value:'1'},
                {label:'80 MHz',value:'2'},
                {label:'20/40/80 MHz',value:'4'},
            ]

            switch (this.wlform.band) {
                case '4': /** 802.11a*/
                    bandwidth = [
                        {label:'20 MHz',value:'0'}
                    ]
                    this.wlform.bandwidth = '0'
                    break;
                case '8': /** 802.11n*/
                case '12': /** 802.11a/n*/
                    bandwidth = [
                        {label:'20 MHz',value:'0'},
                        {label:'40 MHz',value:'1'},
                    ]
                    if(this.wlform.bandwidth === '4' || this.wlform.bandwidth === '2')
                        this.wlform.bandwidth = '1'
                    break;
                case '64': /** 802.11ac*/
                    bandwidth = [
                        {label:'40 MHz',value:'1'},
                        {label:'80 MHz',value:'2'}
                    ]
                    if(this.wlform.bandwidth === '4' || this.wlform.bandwidth === '0')
                        this.wlform.bandwidth = '2'
                    break;
                default:
                    break;
            }

            return bandwidth
        },
    },
    methods:{
        getData(){
            this.getLoad = true

            if(process.env.VUE_APP_FH_ARER === 'TRUE')
            {// 只有TRUE 需要 DFS
                axios
                .post("/JSONAPI",{
                    cmdType:"GET_WL0_FHDSF"
                })
                .then((response)=>{
                    if(response.data.ret == '0')
                    {
                        this.dsfEnable = !response.data.dsfDisabled
                        if(this.dsfEnable) this.channelNumArr = channelDFSArr
                        else this.channelNumArr = channelNODFSArr
                    }
                })
            }
            
            if(this.$isINTL) 
                this.channelNumArr = channelArrIntl
            else if(this.$isAis){
                if(this.$G_DEVICE_CFG.isFindSubRouter){
                    this.channelNumArr = channelDFSArrAis
                }
                else{
                    this.channelNumArr = channelArrAis
                }
            } 

            axios
            .post("/boafrm/fhAdvancedWlan",{
                CmdType:"GET_ADVANCED_WLAN",
                ssidIndex:"4" // only SSID5
            })
            .then((response)=>{
                this.getLoad = false
                if(response.data.ret == '0')
                {
                    this.wlform.band = response.data.band
                    this.wlform.bandwidth = response.data.bandwidth
                    this.wlform.beaconInterval = response.data.beaconInterval
                    this.wlform.channel = response.data.channel
                    this.wlform.controlSideband = response.data.controlSideband
                    this.wlform.dtimPeriod = response.data.dtimPeriod
                    this.wlform.fragThreshold = response.data.fragThreshold
                    this.wlform.maxinumClients = response.data.maxinumClients
                    this.wlform.power = response.data.power
                    powerCache = response.data.power
                    this.wlform.rtsThreshold = response.data.rtsThreshold
                    this.wlform.shortGI = response.data.shortGI
                    this.wlform.uapsdEnabled = response.data.uapsdEnabled
                    this.wlform.wmmEnabled = response.data.wmmEnabled
                    this.wlform.roamEnable = response.data.roamEnable
                    this.wlform.adaptivityEnable = response.data.adaptivityEnable
                    this.wlform.ATFEnable = response.data.ATFEnable
                    this.wlform.TXBFEnable = response.data.TXBFEnable
                    this.autoText = `auto(${response.data.wlCurrentChannel})`
                }
            })
        },
        setData(){
            const loadingInstance = this.$loading({lock: true})
            axios
            .post("/boafrm/fhAdvancedWlan",{
                CmdType:"SET_ADVANCED_WLAN",
                ssidIndex:"4", // only SSID4
                band: this.wlform.band,
                bandwidth: this.wlform.bandwidth,
                beaconInterval: this.wlform.beaconInterval,
                channel: this.wlform.channel,
                controlSideband: this.wlform.controlSideband,
                dtimPeriod: this.wlform.dtimPeriod,
                fragThreshold: this.wlform.fragThreshold,
                maxinumClients: this.wlform.maxinumClients,
                power: this.wlform.power,
                rtsThreshold: this.wlform.rtsThreshold,
                shortGI: this.wlform.shortGI,
                uapsdEnabled: this.wlform.uapsdEnabled,
                wmmEnabled: this.wlform.wmmEnabled,
                roamEnable: this.wlform.roamEnable,
                adaptivityEnable: this.wlform.adaptivityEnable,
                ATFEnable: this.wlform.ATFEnable,
                TXBFEnable:this.wlform.TXBFEnable
            })
            .then((response)=>{
                setTimeout(()=>{
                    loadingInstance.close()
                    if(powerCache !== this.wlform.power)
                    {
                        powerCache = this.wlform.power
                        this.$message.success("Configuration is successful! the device shall be restarted before it can take effect. If necessary, please restart the device manually.")
                    }
                    else
                    {
                        this.$message.success("Configuration is successful!")
                    }
                },6000)
            })
        },
        tipReboot(val){
            if(val !== powerCache)
            {
                this.$alert('To modify transmission power parameters, the device shall be restarted before it can take effect. If necessary, please restart the device manually.', 'Warning', {
                    confirmButtonText: 'Confirm',
                    type: 'warning'
                })
            }
        },
        apply(){
            this.$refs['wlform'].validate((valid) => {
                if (valid) {
                    this.setData()
                } else {
                    return false
                }
            })
        },
        refresh(){
            this.$refs['wlform'].resetFields()
            this.getData()
        },
        setDFS(){
            const loadingInstance = this.$loading({lock: true})
            axios
            .post("/JSONAPI",{
                cmdType:"SET_WL0_FHDSF",
                dsfDisabled:!this.dsfEnable
            })
            .then((response)=>{
                loadingInstance.close()
                if(response.data.ret === 0)
                {
                    if(!this.dsfEnable) // 雷达信道关闭 需要去掉雷达信道
                        this.channelNumArr = channelNODFSArr
                    else
                        this.channelNumArr = channelDFSArr
                    
                    this.$message.success('DFS Configuration is success!')
                }
                else
                    this.$message.error(`DFS Configuration failed! Error:${response.data.errMsg}`)
            })
            .catch((error) => {
                loadingInstance.close()
                this.$message.error('DFS Configuration failed! Network connection error!')
            })
        }
    },
}
</script>

<style>
.fhv-password{
    cursor:pointer
}
</style>




